{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Valige üksus",
  "tableResizer": "Suuruse muutja",
  "colorSwatchPicker": "Color swatches"
}
